import {Inject, Injectable} from '@angular/core';
import {LoiHttpClient} from 'loi-lti-common';
import {Observable} from 'rxjs';
import { CustomRequestOptions } from '../utils/custom-request-options';

@Injectable({
  providedIn: 'root'
})
export class CampusUrlService {
  constructor(
    private loiHttpClient: LoiHttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private requestOptions: CustomRequestOptions) { }

  getSelfServiceUrl(): Observable<string> {
    return this.loiHttpClient.get<string>(`${this.baseUrl}api/CampusUrl/GetSelfServiceUrl`, this.requestOptions);
  }

  getQAUrl(): Observable<string> {
    return this.loiHttpClient.get<string>(`${this.baseUrl}api/CampusUrl/GetQAUrl`, this.requestOptions);
  }

  getLearningPathUrlForModule(module): Observable<string> {
    return this.loiHttpClient.get<string>(`${this.baseUrl}api/CampusUrl/GetLearningPathUrl/${module}`, this.requestOptions);
  }

}
